import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { WorkerPoolsTableRow } from "../types";

const WorkerPoolsTableBusyCell = ({
  item: row,
  ...cellProps
}: TableSimpleCellProps<WorkerPoolsTableRow>) => {
  const busyWorkers =
    row.kind === "private" ? row.workerPool.busyWorkers : row.publicWorkerPool.busyWorkers;

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{busyWorkers}</TableCellText>
    </TableSimpleCell>
  );
};

export default WorkerPoolsTableBusyCell;
